
<div
  class="c-header-search"
  :class="{ 'is-expanded': isHighlightsPanelVisible }"
  @keyup.esc="setIsHighlightsPanelVisible(false)"
>
  <form
    ref="form"
    class="c-header-search__container"
    :action="formAction"
    role="search"
    autocomplete="off"
    @submit.prevent="hasValidTerm && submitForm()"
  >
    <div class="c-header-search__header">
      <div class="o-grid -xs-middle -xs-gutter-medium">
        <div class="o-grid__item -lg-grow">
          <div class="c-header-search__field">
            <component
              :is="isMobile ? 'div' : 'button'"
              class="c-header-search__field-submit-button"
              :type="isDesktop && 'submit'"
              aria-label="Pesquisar"
              :aria-hidden="isMobile"
              data-test="button-filtro-pesquisa"
            >
              <vIcon
                name="search"
                color="primary"
              />
            </component>

            <button
              v-cloak
              type="button"
              class="c-header-search__field-clean-button"
              :class="{
                'is-hidden': !term.length
              }"
              @click="clear"
            >
              <vIcon
                name="cross"
                color="primary"
                size="xxsmall"
              />
            </button>

            <input
              ref="input"
              v-model.trim="term"
              data-test="input-filtro-pesquisa"
              type="search"
              name="query"
              autocomplete="off"
              autocapitalize="off"
              spellcheck="false"
              autocorrect="off"
              class="o-input -xs-medium t-fill"
              aria-label="busca"
              :placeholder="`Busque ${placeholder}`"
              @blur="!isMobile && setIsHighlightsPanelVisible(false)"
              @mousedown="handleInputClick"
              @input="handleInput"
            >

            <input
              v-if="isProductContext"
              type="hidden"
              name="ref"
              :value="productsSearchRef"
            >
          </div>
        </div>

        <div class="o-grid__item -xs-shrink c-header-search__cancel">
          <button
            type="button"
            class="o-text -xs-semibold -xs-brevier -xs-primary"
            @click="cancel"
          >
            cancelar
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="!isLargeDesktop"
      class="c-header-search__expansion"
    >
      <vSearchHighlightsContent
        :initial-context="initialContext"
      />
    </div>
  </form>
</div>
